import {getTabSessionId} from '@/app/helpers/getTabSessionId';
import {sendStats} from '@/common/helpers/stats/sendStats';

export function reportLoadPageStats(renderTime: number, interfaceName: string) {
	try {
		const observer = new PerformanceObserver((list, obs) => {
			const fcp = list.getEntriesByName('first-contentful-paint')[0];
			if (!fcp) {
				return;
			}

			// Time from navigation start to content shown
			const fcpTimeValue = Math.round(fcp.startTime);

			// Time from navigation start to application render time (script initialized and init client rendering/hydration)
			const renderTimeValue = Math.round(renderTime);

			sendStats(`load/v1/${Date.now()}/${getTabSessionId()}/${interfaceName}/${fcpTimeValue}/${renderTimeValue}`);

			obs.disconnect();
		});

		observer.observe({type: 'paint', buffered: true});
	} catch (error) {
		console.error(error);
	}
}
